var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconDiversity2 = function SvgIconDiversity2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 49.73C16.018 49.73 6.27 39.982 6.27 28 6.27 16.02 16.019 6.272 28 6.272c11.982 0 21.73 9.748 21.73 21.73 0 11.981-9.748 21.729-21.73 21.729Zm0-39.667c-9.89 0-17.938 8.047-17.938 17.938 0 9.89 8.048 17.937 17.938 17.937 9.89 0 17.937-8.047 17.937-17.937S37.89 10.063 28 10.063Z",
    fill: "#94C6F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.708 35.584H37.042c-.645 0-1.167.522-1.167 1.167v11.666c0 .645.522 1.167 1.167 1.167h11.666c.645 0 1.167-.522 1.167-1.167V36.751c0-.645-.522-1.167-1.167-1.167Z",
    fill: "#7666EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m12.59 35.343-6.415 6.416a1.167 1.167 0 0 0 0 1.65l6.416 6.416a1.167 1.167 0 0 0 1.65 0l6.416-6.416a1.166 1.166 0 0 0 0-1.65l-6.416-6.416a1.167 1.167 0 0 0-1.65 0Z",
    fill: "#15C480"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.417 19.834a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z",
    fill: "#FFC82A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m41.866 6.947-6.122 10.605c-.45.78.11 1.75 1.009 1.75H49c.898 0 1.458-.97 1.01-1.75L43.886 6.947a1.166 1.166 0 0 0-2.021 0Z",
    fill: "#F0464F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.006 27.126a4.083 4.083 0 1 0 0-8.167 4.083 4.083 0 0 0 0 8.167ZM33.037 35.875H22.966c-1.7 0-2.841-1.765-2.124-3.308 1.246-2.671 3.982-4.395 7.158-4.395s5.915 1.726 7.157 4.395c.718 1.54-.422 3.308-2.123 3.308h.003Z",
    fill: "#3987F8"
  })));
};
export default SvgIconDiversity2;